export const faqData = {
  title: "es.faq.title",
  description: "es.faq.description",
  questions: [
    {
      question: "es.faq.questions.0.question",
      answer: "es.faq.questions.0.answer"
    },
    {
      question: "es.faq.questions.1.question",
      answer: "es.faq.questions.1.answer"
    },
    {
      question: "es.faq.questions.2.question",
      answer: "es.faq.questions.2.answer"
    },
    {
      question: "es.faq.questions.3.question",
      answer: "es.faq.questions.3.answer"
    },
    {
      question: "es.faq.questions.4.question",
      answer: "es.faq.questions.4.answer"
    },
    {
      question: "es.faq.questions.5.question",
      answer: "es.faq.questions.5.answer"
    },
    {
      question: "es.faq.questions.6.question",
      answer: "es.faq.questions.6.answer"
    },
    {
      question: "es.faq.questions.7.question",
      answer: "es.faq.questions.7.answer"
    },
    {
      question: "es.faq.questions.8.question",
      answer: "es.faq.questions.8.answer"
    },
    {
      question: "es.faq.questions.9.question",
      answer: "es.faq.questions.9.answer"
    },
    {
      question: "es.faq.questions.10.question",
      answer: "es.faq.questions.10.answer"
    },
    {
      question: "es.faq.questions.11.question",
      answer: "es.faq.questions.11.answer"
    }
  ],
}